import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.setDefaultPOPDFLabelSet.presenters.useSetDefaultPOPDFLabelSetPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  setAsDefaultMessage: {
    id: `${scope}.setAsDefaultMessage`,
    defaultMessage: '{name} PDF label has been set as default',
  },
  removedAsDefaultMessage: {
    id: `${scope}.removedAsDefaultMessage`,
    defaultMessage: '{name} label has been removed as default',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to update the default label set.',
  },
})
